import type { Namespace, TFunction } from 'i18next'
import type { z } from 'zod'
import type { ValidationRuleFactory } from './types.ts'

export function createErrorMap<TNamespace extends Namespace>(
  t: TFunction<TNamespace>,
  factory: ValidationRuleFactory<TNamespace>,
  context?: Record<string, unknown>
) {
  const rules = factory(t, context)

  return (issue: z.ZodIssueOptionalMessage, ctx: z.ErrorMapCtx) => {
    for (const rule of rules) {
      const result = rule(issue, ctx)

      if (result?.message) {
        return result
      }
    }

    return { message: ctx.defaultError }
  }
}
